import React from 'react';
import Spinner from '../Spinner';
import { useTranslation } from 'react-i18next';

import styles from './WholeScreenLoading.module.scss';

export interface WholeScreenLoadingProps {
	id?: string;
}

const WholeScreenLoading = ({ id }: WholeScreenLoadingProps) => {
	const { t, i18n } = useTranslation();
	return (
		<div className={styles.container} key={i18n.language}>
			<Spinner id={id} text={t('actions.loading', { defaultValue: 'LOADING' })} size='fullpage' />
		</div>
	);
};

export default WholeScreenLoading;
